// This file is AUTOGENERATED, do not edit it manually!!!

export const messageBoard = {
    Attachment_Delete: 'Dosya \'{0}\' kaldırıldı.',
};
